import {organization_type} from "@/models/organization.model.ts";
import {uuid} from "@/interfaces";

export interface SignupPayload {
    name: string;
    email: string;
    phone?: string;
    password: string;

    organizationType: organization_type;
    organizationName?: string;
}

export interface SignupResponse {
    user_id?: uuid;
    auth_id: uuid;
    organization_id?: uuid;
}

export enum SignupType {
    plain = "plain",
    org_invite = "org_invite",
}

export interface SignupPreflightResponse {
    type: SignupType;
    // Note: no invite token here — the token is only delivered via the emailed
    // invite link, never surfaced to an unauthenticated preflight caller.
    inviteeOrgType?: organization_type;
}